import classes from './accordionComponent.scss';
import PropTypes from 'prop-types';
import Enum from 'enum';
var accordionTypeEnum = new Enum({ 'accordionDefault': 'sceDefaultAccordion', 'sceAccordionWithButton': 'sceAccordionWithButton', 'sceAccordionHistory': 'sceAccordionHistory', 'sceAccordionSecondary':'sceAccordionSecondary' });
var chevronTypeEnum = new Enum({ 'chevronWhite': 'chevronWhite', 'chevronBlack': 'chevronBlack','chevronGreen':'chevronGreen' });

class AccordionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBlock: !!this.props.expandOnInit
    };
    this.toggleBlock = this.toggleBlock.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.expandOnInit !== nextProps.expandOnInit) {
      this.setState({ showBlock: !!nextProps.expandOnInit });
    }
  } 

  /**
   * Decides whether to hide or show the block on click event handler
   */
  toggleBlock() {
    this.setState({ showBlock: !this.state.showBlock },()=>{
      if (this.state.showBlock){
        // this.refs.accordionContent.scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" });
        let elementRect = this.refs.accordionContent.getBoundingClientRect();
        let absoluteElementTop = elementRect.top + window.pageYOffset;
        let middle = absoluteElementTop - (window.innerHeight / 2);
        window.scrollTo(0, middle);
      }
      if(this.props.isContentRequired){
      this.refs.accordionContent.focus();
    }
    });
    
    // app.logger.getLogger().info(this.refs.accordionContent);
    this.props.triggerOnClick ? this.props.triggerOnClick() : '';
  }

  handleKeyPress(event, isAccordionBlock) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // app.logger.getLogger().info(event.key,isAccordionBlock);
      isAccordionBlock();
    }
  }
  /**
   * Renders the accordion 
   */
  render() {
    //Constants
    const toggleClass = this.state.showBlock ? '' : classes.hideBlock;
    const isAccordionBlock = (this.props.customTextOnOpen || this.state.customTextOnClose) ? '' : this.toggleBlock;
    const isAccordionWithBtn = (this.props.customTextOnOpen || this.state.customTextOnClose) ? this.toggleBlock : '';
    const accordionClass = classes[accordionTypeEnum.get(this.props.accordionType) + ''];
    const chevronClass = classes[chevronTypeEnum.get(this.props.chevronType) + ''];
    const accordionSecTitleClass = this.props.accordionType === 'sceAccordionSecondary' ? classes.accordionSecTitle : '';
    const secondaryTextJsx = this.props.secondaryText ? <span className={classes.secondaryText}>{this.props.secondaryText}</span> : '';
    const tertiaryTextJsx = this.props.tertiaryText ? <span className={classes.tertiaryText}>{this.props.tertiaryText}</span> : '';

    return (
      <div className={['row', classes.sceAccordionHeader].join(' ')}>
        <div className='col-xs-12'>
          <div onClick={isAccordionBlock} onKeyPress={(event) => this.handleKeyPress(event, isAccordionBlock)} tabIndex='0' className={accordionClass}>
            <span className={accordionSecTitleClass}>
              {this.props.headerText}
                {secondaryTextJsx}
                {tertiaryTextJsx}
            </span>
            {isAccordionBlock ? (
              toggleClass ?
                (<span className={chevronClass}><i className='fas fa-chevron-down' /></span>) :
                (<span className={chevronClass}><i className='fas fa-chevron-up' /></span>)
            ) : (toggleClass ?
              (<span className={classes.sceFloatRight}>
                <button className={classes.sceAccordionButtonText} onClick={isAccordionWithBtn}>{this.props.customTextOnOpen}<span className={classes.sceChevronIconWithBtn}><i className='fas fa-chevron-down' /></span></button>
              </span>) :
              (<span className={classes.sceFloatRight}>
                <button className={classes.sceAccordionButtonText} onClick={isAccordionWithBtn}>{this.props.customTextOnClose}<span className={classes.sceChevronIconWithBtn}><i className='fas fa-chevron-up' /></span></button>
              </span>)
              )}
          </div>
          <div className={classes.sceAccordionContent + ' ' + toggleClass} ref='accordionContent'>
            {this.props.lazyLoad?(this.state.showBlock?React.Children.only(this.props.children):null):React.Children.only(this.props.children)} 
          </div>
        </div>
      </div>
    );

  }
}

AccordionComponent.propTypes = {
 // expandOnInit: PropTypes.string,
 expandOnInit: PropTypes.bool,
  triggerOnClick: PropTypes.func,
  headerText: PropTypes.string,
};

export default AccordionComponent;
